import React, { useState, useEffect } from "react";
import "./Style/common.css";
import "./Style/Profile.css";
import Header from "../../Common/Header";
import dotsDark from "./Image/dots_dark.png";

const Profile: React.FC = () => {

  const FName = sessionStorage.getItem("FName");
  const CurrentAvatar = sessionStorage.getItem("CurrentAvatar");
  // const [name, setName] = useState();
  const [gender, setGender] = useState("-");
  const [dob, setDob] = useState("-");
  const [resetEmail, setResetEmail] = useState("");
  const [showResetPasswordPopup, setShowResetPasswordPopup] = useState(false);
  const [isResetPasswordLoading, setIsResetPasswordLoading] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState("");
  const [resetPasswordNotice, setResetPasswordNotice] = useState("");
  const grade = sessionStorage.getItem("Grade");

  const [
    // isMenuVisible
    , setIsMenuVisible] = useState(false);
  const [
    // imageSrc
    , setImageSrc] = useState('');
  // const navigate = useNavigate();


  // const handleModifyDetails = () => {
  //   // console.log("Modify details clicked");
  // };

  // const handleChangeAvatar = () => {
  //   // console.log("Change avatar clicked");
  //   navigate('/ChangeAvatar');
  // };

  // const handleModifyLessonPlan = () => {
  //   // console.log("Modify lesson plan clicked");
  // }

  const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${apiUrl}get_profile_details/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            SchoolCode: sessionStorage.getItem("SchoolCode"),
            FamilyCode: sessionStorage.getItem("FamilyCode"),
            Login: sessionStorage.getItem("Login"),
          }),
        });

        const data = await response.json();

        if (response.ok) {
          setGender(data.Gender);
          setDob(data.DOB);
        }
      } catch (error) {
        console.error("Error fetching profile details:", error);
      }
    };

    fetchProfile();
  }, [apiUrl]);

  const requestPasswordReset = async (isResend = false) => {
    setIsResetPasswordLoading(true);
    setResetPasswordError("");
    setResetPasswordNotice("");

    try {
      const response = await fetch(`${apiUrl}send_profile_password_reset/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          SchoolCode: sessionStorage.getItem("SchoolCode"),
          FamilyCode: sessionStorage.getItem("FamilyCode"),
          Login: sessionStorage.getItem("Login"),
        }),
      });
      const data = await response.json();

      if (!response.ok || !data.success || typeof data.maskedEmail !== "string") {
        throw new Error(data.error || "Unable to send the reset password email. Please try again later.");
      }

      setResetEmail(data.maskedEmail);
      if (isResend) {
        setResetPasswordNotice("A new reset email has been sent.");
      } else {
        setShowResetPasswordPopup(true);
      }
    } catch (error) {
      setResetPasswordError(
        error instanceof Error
          ? error.message
          : "Unable to send the reset password email. Please try again later."
      );
    } finally {
      setIsResetPasswordLoading(false);
    }
  };

  const handleClickOutside = (e: MouseEvent | TouchEvent) => {
    if (!(e.target instanceof Element)) return;

    if (!e.target.closest('#mobile_box') && !e.target.closest('#mobile_menu')) {
      setIsMenuVisible(false);
    }
  };

  // const handleMobileBoxClick = (e: MouseEvent | TouchEvent) => {
  //   e.stopPropagation(); 
  // };

  useEffect(() => {
    window.addEventListener('mouseup', handleClickOutside);
    window.addEventListener('touchend', handleClickOutside);

    return () => {
      window.removeEventListener('mouseup', handleClickOutside);
      window.removeEventListener('touchend', handleClickOutside);
    };
  }, []);

  return (
    <form id="form1">
      <div>
        <div id="main_top_container">
          <Header />
          <div id="msr_my_profile_title_bar" className="section_container section_title_bar">
            <div id="bt_msr_my_profile" className="section_div bar_section"></div>
          </div>
        </div>
        <div id="msr_my_profile" className="msr_my_profile_bgcolor" style={{ backgroundColor: "#121316", backgroundImage: `url(${dotsDark})`, height: "87vh" }}>
          <div className="section_div" id="section_div">
            <div className="centered_container">
              <div className="section_block">
                <div id="section_icon_01" className="section_icon"></div>
                <div className="right_content">
                  <p className="section_title">Profile</p>
                  <hr className="msr_my_profile_hr" />
                  <div className="left_text">
                    <p className="section_text">
                      <b>
                        Name<br />
                        Gender<br />
                        Date of birth<br />
                        Grade/Year<br />
                      </b>
                    </p>
                  </div>
                  <div className="right_text">
                    <p className="section_text">
                      {FName}<br />
                      {gender}<br />
                      {dob}<br />
                      {grade}<br />
                    </p>
                  </div>
                  <button
                    className="section_link reset_password_link"
                    type="button"
                    onClick={() => void requestPasswordReset()}
                    disabled={isResetPasswordLoading}
                  >
                    {isResetPasswordLoading ? "Sending..." : "Reset Password"}
                  </button>
                  {resetPasswordError && (
                    <p className="reset_password_error" role="alert">{resetPasswordError}</p>
                  )}
                  {/* <a className="section_link" onClick={handleModifyDetails}>
                      Modify details
                    </a> */}
                </div>
              </div>
              <div className="section_block">
                <div id="section_icon_02" className="section_icon"></div>
                <div className="right_content">
                  <p className="section_title">My Avatar</p>
                  <hr className="msr_my_profile_hr" />
                  <div id="avatar_container">
                    <div id="divCurrentAvatar" className="avatar_box">
                      {CurrentAvatar ? (
                        <img id="imgAvatar" src={CurrentAvatar} alt="Avatar" />
                      ) : null}
                    </div>
                  </div>
                  <div id="mobile_Change">
                    <div id="mobile_Avatar" className="mobile_dropdown">
                      <div className="mobile_nav_item">
                        <a id="lnkChangeAvatarMobile" className="section_link" href="/STUDENT/MSR/ChangeAvatar"
                        // onClick={handleChangeAvatar}
                        >Change Avatar</a>
                      </div>
                    </div>
                  </div>
                  <a className="section_link" href="/STUDENT/MSR/ChangeAvatar"
                  // onClick={handleChangeAvatar}
                  >
                    Change avatar
                  </a>
                  <a className="section_link" href="/STUDENT/MSR/MyIncentives">Get more avatars</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showResetPasswordPopup && (
        <div className="popup_overlay">
          <div
            className="popup_box"
            role="dialog"
            aria-modal="true"
            aria-labelledby="reset_password_title"
          >
            <div id="reset_password_title" className="popup_title">Reset Password</div>
            <div className="popup_message">
              An email with a link to reset your password has been sent to:
              <br />
              <span className="reset_email_text">{resetEmail}</span>
              <br />
              <br />
              Make sure to check your spam folder. If you still haven&apos;t received it,{" "}
              <button
                type="button"
                className="reset_password_resend"
                onClick={() => void requestPasswordReset(true)}
                disabled={isResetPasswordLoading}
              >
                {isResetPasswordLoading ? "Sending..." : "Resend Email"}
              </button>
              {resetPasswordNotice && <p role="status">{resetPasswordNotice}</p>}
              {resetPasswordError && <p className="reset_password_error" role="alert">{resetPasswordError}</p>}
            </div>
            <button
              type="button"
              className="popup_ok_btn"
              onClick={() => setShowResetPasswordPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default Profile;